import {computed, inject, Injectable, Signal} from '@angular/core';
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {toSignal} from "@angular/core/rxjs-interop";
import {map} from "rxjs";

/**
 * Holds state for the current client screen size.
 */
@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private breakPointObserver = inject(BreakpointObserver);

  // Private observer state
  private isHandset = toSignal(this.breakPointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
    .pipe(map(result => result.matches)));

  private isTablet= toSignal(this.breakPointObserver.observe(Breakpoints.Medium)
    .pipe(map(result => result.matches)));

  // Expose signal of current screen size to consumers
  screenSize: Signal<"mobile" | "tablet" | "desktop"> = computed(() => {
    if (this.isHandset()) {
      return "mobile";
    } else if (this.isTablet()) {
      return "tablet";
    } else {
      return "desktop"
    }
  });
}
